import { ChangeDetectionStrategy, Component, signal, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NavigationService } from '../navigation.service';
import { BOTTOM_BAR_ITEM_IDS, NavItem } from '../nav-model';

@Component({
  selector: 'myabvv-home-grid',
  standalone: true,
  templateUrl: './home-grid.component.html',
  styleUrl: './home-grid.component.css',
  imports: [RouterLink, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeGridComponent {
  private navigation = inject(NavigationService);

  readonly tiles = signal<NavItem[]>([]);
  constructor() {
    // The "Plus" launcher shows every destination except those already in the bottom bar.
    const inBottomBar = new Set<string>(BOTTOM_BAR_ITEM_IDS);
    this.tiles.set(this.navigation.getItems().filter(item => !inBottomBar.has(item.id)));
  }
}
